import { createStore } from 'vuex'

export default createStore({
  state: {
    profile: {},
  },
  getters: {
  },
  mutations: {
    setProfileState: (state, data) => {
      state.profile = data
    },
  },
  actions: {
    setProfileAction: ({commit}, data) => {
      commit('setProfileState', data)
    },
  },
  modules: {
  }
})
